import React from "react";

// Hooks
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// Components
import { HexColorInput, HexColorPicker } from "react-colorful";

// Types
import { CSSProperties } from "react";

export default function ColorInput(props: any) {
  const [color, setColor] = useState<string>(props.value);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const pickerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener("click", handleClickOutside, true);

    return () => {
      window.removeEventListener("click", handleClickOutside, true);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="input__container input__container--type-color" style={{ "--currentColor": color } as CSSProperties}>
      <button className="input__container--type-color__toggle" aria-label={t("toggleColorPicker") as string} onClick={openColorPicker}>
        {isOpen && (
          <div className="input__container--type-color__picker" ref={pickerRef}>
            <HexColorPicker color={color} onChange={handleChange} />
            <HexColorInput color={color} onChange={handleChange} />
          </div>
        )}
      </button>
    </div>
  );

  function openColorPicker() {
    setIsOpen(true);
  }

  function closeColorPicker() {
    setIsOpen(false);
  }

  function handleChange(color: string) {
    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: props.name,
        value: color,
      },
    });

    props.onIonChange(ionEvent);
    setColor(color);
  }

  function handleClickOutside(event: MouseEvent) {
    const pickerElement = pickerRef.current;

    if (pickerElement && !pickerElement.contains(event.target as Node)) {
      closeColorPicker();
    }
  }
}
